import { memo } from 'react';
import css from './LegalDocumentModal.module.scss';
import { useLocale, useLocalization } from '../../../context/Localization/localization';
import { Locales, LocalizationType } from '../../../context/Localization/localization.types';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import { GMSizedIcon } from '../../Icon';
import { getLegalDocumentUrl } from '../getLegalDocumentUrl';
import type { LegalDocumentModalProps } from './LegalDocumentModal.types';

export const LegalDocumentModal: GoMotoComponent<LegalDocumentModalProps> = memo(({ documentType, open, onClose }) => {
    const Localization: LocalizationType = useLocalization();
    const locale: Locales = useLocale();

    const url: string = getLegalDocumentUrl(documentType, locale);
    const title: string = documentType === 'terms' ? Localization.TermsOfUse : Localization.PrivacyPolicy;

    if (!open) {
        return null;
    }
    else {
        return (
            <div className={css.popUpContainer}>
                <header className={css.popUpHeader}>
                    <h1 className={css.popUpHeaderTitle}>{title}</h1>
                    <button
                        type={'button'}
                        className={css.closeButton}
                        onClick={onClose}
                        title={Localization.ClickToCloseWindow}
                        aria-label={Localization.ClickToCloseWindow}
                    >
                        <GMSizedIcon
                            iconType={'X'}
                            ariaLabel={''}
                            iconSize={'custom'}
                        />
                    </button>
                </header>
                <div className={css.iframeContainer}>
                    <iframe
                        className={css.iframe}
                        src={url}
                        title={title}
                        sandbox={'allow-same-origin'}
                    />
                </div>
            </div>
        );
    }
});
